import type { CityEstimate } from "./types";

/** Whether the city's price is still coming in: its fares or its hotel rate are loading. */
const settling = (city: CityEstimate): boolean => city.flights.loading || city.hotel.loading;

/**
 * The city list's order: cheapest first by the low end of the per-person range, or of the
 * group total when the planner is viewing totals. A city whose fares or hotel are still loading
 * isn't ranked yet (its partial price would put it first, then drop it once the rest lands): it
 * waits after the priced cities, in the order given, and moves once, into place, when it settles.
 * @param cities - The cities.
 * @param byTotal - Rank by the group total.
 * @returns A ranked copy.
 * @throws Never.
 */
export const rankCities = (cities: readonly CityEstimate[], byTotal: boolean): CityEstimate[] => {
  const low = (city: CityEstimate) => (byTotal ? city.total.low : city.perPerson.low);
  const priced = cities.filter((city) => !settling(city)).sort((a, b) => low(a) - low(b));
  return [...priced, ...cities.filter(settling)];
};
